/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VisionSdkTrainingTokenResponse } from '../../models/vision-sdk-training-token-response';
import { VisionTrainingTokenRequest } from '../../models/vision-training-token-request';

export interface VisionSdkTrainingTokenPost$Params {
      body?: VisionTrainingTokenRequest
}

export function visionSdkTrainingTokenPost(http: HttpClient, rootUrl: string, params?: VisionSdkTrainingTokenPost$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<VisionSdkTrainingTokenResponse>> {
  const rb = new RequestBuilder(rootUrl, visionSdkTrainingTokenPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VivaLiteScanStrictHttpResponse<VisionSdkTrainingTokenResponse>;
    })
  );
}

visionSdkTrainingTokenPost.PATH = '/VisionSdk/TrainingToken';
